import { Tooltip } from 'antd';
import { ColumnType } from 'antd/es/table';
import {
  IExpiringPolicies,
  IOrganization,
  IReconciliationDashboard,
} from '../../types';
import { IEnum } from '../../services/type';
import { formatCurrencyTRY } from '../../utils/functions';

export const getColumnsForExpiringPolicies = (
  policyModels: IEnum[],
): Array<ColumnType<IExpiringPolicies> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization_name',
    key: 'organization_name',
    sorter: (a, b) => a.organization_name?.localeCompare(b.organization_name),
  },
  {
    title: 'Poliçe Tipi',
    dataIndex: 'policy_type',
    key: 'policy_type',
    width: 175,
    sorter: (a, b) => a.policy_type?.localeCompare(b.policy_type),
    searchable: true,
    render: (_, record) => (
      <div>
        {policyModels.find((item) => item.key === record.policy_type)?.value}
      </div>
    ),
  },
  {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    searchable: true,
    width: 150,
    sorter: (a, b) => a.policy_number?.localeCompare(b.policy_number),
  },
  {
    title: 'Bitiş Tarihi',
    dataIndex: 'end_date',
    key: 'end_date',
    sorter: true,
  },
];

export const getColumnsForReconciliationDashboard = (
  organizations: IOrganization[],
  currentAccounts: IEnum[],
): Array<ColumnType<IReconciliationDashboard> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    width: 125,
    searchable: true,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name?.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Cari Bilgiler',
    dataIndex: 'current_account',
    key: 'current_account',
    width: 130,
    sorter: (a, b) => a.current_account?.localeCompare(b.current_account),
    render: (_, record) => (
      <div>
        {
          currentAccounts.find((item) => item.key === record.current_account)
            ?.value
        }
      </div>
    ),
  },
  {
    title: 'Mutabakat Tarihi',
    dataIndex: 'reconciliation_date',
    key: 'reconciliation_date',
    width: 160,
    sorter: (a, b) =>
      a.reconciliation_date?.localeCompare(b.reconciliation_date),
  },
  {
    title: 'Toplam Borç',
    dataIndex: 'total_debt',
    key: 'total_debt',
    width: 130,
    sorter: (a, b) => a.total_debt - b.total_debt,
    render: (_, record) => (
      <div>
        {formatCurrencyTRY(record.total_debt)} {record.currency_label}
      </div>
    ),
  },
  {
    title: 'Vadesi Geçmiş',
    dataIndex: 'due_debt',
    key: 'due_debt',
    width: 150,
    sorter: (a, b) => a.due_debt - b.due_debt,
    render: (_, record) => (
      <div>
        {formatCurrencyTRY(record.due_debt)} {record.currency_label}
      </div>
    ),
  },
];
